/* unplugin-vue-components disabled */import script from "./nav_header.vue?vue&type=script&setup=true&lang=js"
export * from "./nav_header.vue?vue&type=script&setup=true&lang=js"

import "./nav_header.vue?vue&type=style&index=0&id=44512872&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44512872"]])

export default __exports__